export enum TyaIconData {
  "tya-align-center-p" = "pi-align-center",
  "tya-align-justify-p" = "pi-align-justify",
  "tya-align-left-p" = "pi-align-left",
  "tya-align-right-p" = "pi-align-right",
  "tya-amazon-p" = "pi-amazon",
  "tya-android-p" = "pi-android",
  "tya-angle-double-down-p" = "pi-angle-double-down",
  "tya-angle-double-left-p" = "pi-angle-double-left",
  "tya-angle-double-right-p" = "pi-angle-double-right",
  "tya-angle-double-up-p" = "pi-angle-double-up",
  "tya-angle-down-p" = "pi-angle-down",
  "tya-angle-left-p" = "pi-angle-left",
  "tya-angle-right-p" = "pi-angle-right",
  "tya-angle-up-p" = "pi-angle-up",
  "tya-apple-p" = "pi-apple",
  "tya-arrow-circle-down-p" = "pi-arrow-circle-down",
  "tya-arrow-circle-left-p" = "pi-arrow-circle-left",
  "tya-arrow-circle-right-p" = "pi-arrow-circle-right",
  "tya-arrow-circle-up-p" = "pi-arrow-circle-up",
  "tya-arrow-down-p" = "pi-arrow-down",
  "tya-arrow-left-p" = "pi-arrow-left",
  "tya-arrow-right-p" = "pi-arrow-right",
  "tya-arrow-up-p" = "pi-arrow-up",
  "tya-backward-p" = "pi-backward",
  "tya-ban-p" = "pi-ban",
  "tya-bars-p" = "pi-bars",
  "tya-bell-p" = "pi-bell",
  "tya-book-p" = "pi-book",
  "tya-bookmark-p" = "pi-bookmark",
  "tya-briefcase-p" = "pi-briefcase",
  "tya-calendar-p" = "pi-calendar",
  "tya-calendar-minus-p" = "pi-calendar-minus",
  "tya-calendar-plus-p" = "pi-calendar-plus",
  "tya-calendar-times-p" = "pi-calendar-times",
  "tya-camera-p" = "pi-camera",
  "tya-caret-down-p" = "pi-caret-down",
  "tya-caret-left-p" = "pi-caret-left",
  "tya-caret-right-p" = "pi-caret-right",
  "tya-caret-up-p" = "pi-caret-up",
  "tya-chart-bar-p" = "pi-chart-bar",
  "tya-chart-line-p" = "pi-chart-line",
  "tya-check-p" = "pi-check",
  "tya-check-circle-p" = "pi-check-circle",
  "tya-check-square-p" = "pi-check-square",
  "tya-chevron-circle-down-p" = "pi-chevron-circle-down",
  "tya-chevron-circle-left-p" = "pi-chevron-circle-left",
  "tya-chevron-circle-right-p" = "pi-chevron-circle-right",
  "tya-chevron-circle-up-p" = "pi-chevron-circle-up",
  "tya-chevron-down-p" = "pi-chevron-down",
  "tya-chevron-left-p" = "pi-chevron-left",
  "tya-chevron-right-p" = "pi-chevron-right",
  "tya-chevron-up-p" = "pi-chevron-up",
  "tya-circle-off-p" = "pi-circle-off",
  "tya-circle-on-p" = "pi-circle-on",
  "tya-clock-p" = "pi-clock",
  "tya-clone-p" = "pi-clone",
  "tya-cloud-p" = "pi-cloud",
  "tya-cloud-download-p" = "pi-cloud-download",
  "tya-cloud-upload-p" = "pi-cloud-upload",
  "tya-cog-p" = "pi-cog",
  "tya-comment-p" = "pi-comment",
  "tya-comments-p" = "pi-comments",
  "tya-compass-p" = "pi-compass",
  "tya-copy-p" = "pi-copy",
  "tya-credit-card-p" = "pi-credit-card",
  "tya-desktop-p" = "pi-desktop",
  "tya-directions-p" = "pi-directions",
  "tya-directions-alt-p" = "pi-directions-alt",
  "tya-discord-p" = "pi-discord",
  "tya-dollar-p" = "pi-dollar",
  "tya-download-p" = "pi-download",
  "tya-eject-p" = "pi-eject",
  "tya-ellipsis-h-p" = "pi-ellipsis-h",
  "tya-ellipsis-v-p" = "pi-ellipsis-v",
  "tya-envelope-p" = "pi-envelope",
  "tya-euro-p" = "pi-euro",
  "tya-exclamation-circle-p" = "pi-exclamation-circle",
  "tya-exclamation-triangle-p" = "pi-exclamation-triangle",
  "tya-external-link-p" = "pi-external-link",
  "tya-eye-p" = "pi-eye",
  "tya-eye-slash-p" = "pi-eye-slash",
  "tya-facebook-p" = "pi-facebook",
  "tya-fast-backward-p" = "pi-fast-backward",
  "tya-fast-forward-p" = "pi-fast-forward",
  "tya-file-p" = "pi-file",
  "tya-file-excel-p" = "pi-file-excel",
  "tya-file-o-p" = "pi-file-o",
  "tya-file-pdf-p" = "pi-file-pdf",
  "tya-filter-p" = "pi-filter",
  "tya-filter-slash-p" = "pi-filter-slash",
  "tya-flag-p" = "pi-flag",
  "tya-folder-p" = "pi-folder",
  "tya-folder-open-p" = "pi-folder-open",
  "tya-forward-p" = "pi-forward",
  "tya-github-p" = "pi-github",
  "tya-globe-p" = "pi-globe",
  "tya-google-p" = "pi-google",
  "tya-heart-p" = "pi-heart",
  "tya-home-p" = "pi-home",
  "tya-id-card-p" = "pi-id-card",
  "tya-image-p" = "pi-image",
  "tya-images-p" = "pi-images",
  "tya-inbox-p" = "pi-inbox",
  "tya-info-p" = "pi-info",
  "tya-info-circle-p" = "pi-info-circle",
  "tya-key-p" = "pi-key",
  "tya-link-p" = "pi-link",
  "tya-list-p" = "pi-list",
  "tya-lock-p" = "pi-lock",
  "tya-lock-open-p" = "pi-lock-open",
  "tya-map-p" = "pi-map",
  "tya-map-marker-p" = "pi-map-marker",
  "tya-microsoft-p" = "pi-microsoft",
  "tya-minus-p" = "pi-minus",
  "tya-minus-circle-p" = "pi-minus-circle",
  "tya-mobile-p" = "pi-mobile",
  "tya-money-bill-p" = "pi-money-bill",
  "tya-moon-p" = "pi-moon",
  "tya-palette-p" = "pi-palette",
  "tya-paperclip-p" = "pi-paperclip",
  "tya-pause-p" = "pi-pause",
  "tya-paypal-p" = "pi-paypal",
  "tya-pencil-p" = "pi-pencil",
  "tya-percentage-p" = "pi-percentage",
  "tya-phone-p" = "pi-phone",
  "tya-play-p" = "pi-play",
  "tya-plus-p" = "pi-plus",
  "tya-plus-circle-p" = "pi-plus-circle",
  "tya-power-off-p" = "pi-power-off",
  "tya-print-p" = "pi-print",
  "tya-question-p" = "pi-question",
  "tya-question-circle-p" = "pi-question-circle",
  "tya-refresh-p" = "pi-refresh",
  "tya-replay-p" = "pi-replay",
  "tya-reply-p" = "pi-reply",
  "tya-save-p" = "pi-save",
  "tya-search-p" = "pi-search",
  "tya-search-minus-p" = "pi-search-minus",
  "tya-search-plus-p" = "pi-search-plus",
  "tya-send-p" = "pi-send",
  "tya-share-alt-p" = "pi-share-alt",
  "tya-shield-p" = "pi-shield",
  "tya-shopping-cart-p" = "pi-shopping-cart",
  "tya-sign-in-p" = "pi-sign-in",
  "tya-sign-out-p" = "pi-sign-out",
  "tya-sitemap-p" = "pi-sitemap",
  "tya-slack-p" = "pi-slack",
  "tya-sliders-h-p" = "pi-sliders-h",
  "tya-sliders-v-p" = "pi-sliders-v",
  "tya-sort-p" = "pi-sort",
  "tya-sort-alpha-down-p" = "pi-sort-alpha-down",
  "tya-sort-alpha-down-alt-p" = "pi-sort-alpha-down-alt",
  "tya-sort-alpha-up-p" = "pi-sort-alpha-up",
  "tya-sort-alpha-up-alt-p" = "pi-sort-alpha-up-alt",
  "tya-sort-alt-p" = "pi-sort-alt",
  "tya-sort-amount-down-p" = "pi-sort-amount-down",
  "tya-sort-amount-down-alt-p" = "pi-sort-amount-down-alt",
  "tya-sort-amount-up-p" = "pi-sort-amount-up",
  "tya-sort-amount-up-alt-p" = "pi-sort-amount-up-alt",
  "tya-sort-down-p" = "pi-sort-down",
  "tya-sort-numeric-down-p" = "pi-sort-numeric-down",
  "tya-sort-numeric-down-alt-p" = "pi-sort-numeric-down-alt",
  "tya-sort-numeric-up-p" = "pi-sort-numeric-up",
  "tya-sort-numeric-up-alt-p" = "pi-sort-numeric-up-alt",
  "tya-sort-up-p" = "pi-sort-up",
  "tya-spinner-p" = "pi-spinner",
  "tya-star-p" = "pi-star",
  "tya-star-o-p" = "pi-star-o",
  "tya-step-backward-p" = "pi-step-backward",
  "tya-step-backward-alt-p" = "pi-step-backward-alt",
  "tya-step-forward-p" = "pi-step-forward",
  "tya-step-forward-alt-p" = "pi-step-forward-alt",
  "tya-sun-p" = "pi-sun",
  "tya-table-p" = "pi-table",
  "tya-tablet-p" = "pi-tablet",
  "tya-tag-p" = "pi-tag",
  "tya-tags-p" = "pi-tags",
  "tya-th-large-p" = "pi-th-large",
  "tya-thumbs-down-p" = "pi-thumbs-down",
  "tya-thumbs-up-p" = "pi-thumbs-up",
  "tya-ticket-p" = "pi-ticket",
  "tya-times-p" = "pi-times",
  "tya-times-circle-p" = "pi-times-circle",
  "tya-trash-p" = "pi-trash",
  "tya-twitter-p" = "pi-twitter",
  "tya-undo-p" = "pi-undo",
  "tya-unlock-p" = "pi-unlock",
  "tya-upload-p" = "pi-upload",
  "tya-user-p" = "pi-user",
  "tya-user-edit-p" = "pi-user-edit",
  "tya-user-minus-p" = "pi-user-minus",
  "tya-user-plus-p" = "pi-user-plus",
  "tya-users-p" = "pi-users",
  "tya-video-p" = "pi-video",
  "tya-vimeo-p" = "pi-vimeo",
  "tya-volume-down-p" = "pi-volume-down",
  "tya-volume-off-p" = "pi-volume-off",
  "tya-volume-up-p" = "pi-volume-up",
  "tya-wallet-p" = "pi-wallet",
  "tya-wifi-p" = "pi-wifi",
  "tya-window-maximize-p" = "pi-window-maximize",
  "tya-window-minimize-p" = "pi-window-minimize",
  "tya-youtube-p" = "pi-youtube",
  "tya-activity-outline" = "activity-outline",
  "tya-alert-circle-outline" = "alert-circle-outline",
  "tya-alert-triangle-outline" = "alert-triangle-outline",
  "tya-archive-outline" = "archive-outline",
  "tya-arrow-circle-down-outline" = "arrow-circle-down-outline",
  "tya-arrow-circle-up-outline" = "arrow-circle-up-outline",
  "tya-arrow-circle-left-outline" = "arrow-circle-left-outline",
  "tya-arrow-circle-right-outline" = "arrow-circle-right-outline",
  "tya-arrow-down-outline" = "arrow-down-outline",
  "tya-arrow-up-outline" = "arrow-up-outline",
  "tya-arrow-left-outline" = "arrow-left-outline",
  "tya-arrow-right-outline" = "arrow-right-outline",
  "tya-arrow-downward-outline" = "arrow-downward-outline",
  "tya-arrow-upward-outline" = "arrow-upward-outline",
  "tya-arrow-back-outline" = "arrow-back-outline",
  "tya-arrow-forward-outline" = "arrow-forward-outline",
  "tya-arrow-ios-downward-outline" = "arrow-ios-downward-outline",
  "tya-arrow-ios-upward-outline" = "arrow-ios-upward-outline",
  "tya-arrow-ios-back-outline" = "arrow-ios-back-outline",
  "tya-arrow-ios-forward-outline" = "arrow-ios-forward-outline",
  "tya-arrowhead-down-outline" = "arrowhead-down-outline",
  "tya-arrowhead-up-outline" = "arrowhead-up-outline",
  "tya-arrowhead-left-outline" = "arrowhead-left-outline",
  "tya-arrowhead-right-outline" = "arrowhead-right-outline",
  "tya-at-outline" = "at-outline",
  "tya-attach-2-outline" = "attach-2-outline",
  "tya-attach-outline" = "attach-outline",
  "tya-award-outline" = "award-outline",
  "tya-backspace-outline" = "backspace-outline",
  "tya-bar-chart-2-outline" = "bar-chart-2-outline",
  "tya-bar-chart-outline" = "bar-chart-outline",
  "tya-battery-outline" = "battery-outline",
  "tya-behance-outline" = "behance-outline",
  "tya-bell-off-outline" = "bell-off-outline",
  "tya-bell-outline" = "bell-outline",
  "tya-bluetooth-outline" = "bluetooth-outline",
  "tya-book-open-outline" = "book-open-outline",
  "tya-book-outline" = "book-outline",
  "tya-bookmark-outline" = "bookmark-outline",
  "tya-briefcase-outline" = "briefcase-outline",
  "tya-browser-outline" = "browser-outline",
  "tya-brush-outline" = "brush-outline",
  "tya-bulb-outline" = "bulb-outline",
  "tya-calendar-outline" = "calendar-outline",
  "tya-camera-outline" = "camera-outline",
  "tya-car-outline" = "car-outline",
  "tya-cast-outline" = "cast-outline",
  "tya-charging-outline" = "charging-outline",
  "tya-checkmark-circle-2-outline" = "checkmark-circle-2-outline",
  "tya-checkmark-circle-outline" = "checkmark-circle-outline",
  "tya-checkmark-outline" = "checkmark-outline",
  "tya-checkmark-square-2-outline" = "checkmark-square-2-outline",
  "tya-checkmark-square-outline" = "checkmark-square-outline",
  "tya-chevron-down-outline" = "chevron-down-outline",
  "tya-chevron-left-outline" = "chevron-left-outline",
  "tya-chevron-right-outline" = "chevron-right-outline",
  "tya-chevron-up-outline" = "chevron-up-outline",
  "tya-clipboard-outline" = "clipboard-outline",
  "tya-clock-outline" = "clock-outline",
  "tya-close-circle-outline" = "close-circle-outline",
  "tya-close-outline" = "close-outline",
  "tya-close-square-outline" = "close-square-outline",
  "tya-cloud-download-outline" = "cloud-download-outline",
  "tya-cloud-upload-outline" = "cloud-upload-outline",
  "tya-code-download-outline" = "code-download-outline",
  "tya-code-outline" = "code-outline",
  "tya-collapse-outline" = "collapse-outline",
  "tya-color-palette-outline" = "color-palette-outline",
  "tya-color-picker-outline" = "color-picker-outline",
  "tya-compass-outline" = "compass-outline",
  "tya-copy-outline" = "copy-outline",
  "tya-corner-down-left-outline" = "corner-down-left-outline",
  "tya-corner-down-right-outline" = "corner-down-right-outline",
  "tya-corner-left-down-outline" = "corner-left-down-outline",
  "tya-corner-left-up-outline" = "corner-left-up-outline",
  "tya-corner-right-down-outline" = "corner-right-down-outline",
  "tya-corner-right-up-outline" = "corner-right-up-outline",
  "tya-corner-up-left-outline" = "corner-up-left-outline",
  "tya-corner-up-right-outline" = "corner-up-right-outline",
  "tya-credit-card-outline" = "credit-card-outline",
  "tya-crop-outline" = "crop-outline",
  "tya-cube-outline" = "cube-outline",
  "tya-diagonal-arrow-left-down-outline" = "diagonal-arrow-left-down-outline",
  "tya-diagonal-arrow-left-up-outline" = "diagonal-arrow-left-up-outline",
  "tya-diagonal-arrow-right-down-outline" = "diagonal-arrow-right-down-outline",
  "tya-diagonal-arrow-right-up-outline" = "diagonal-arrow-right-up-outline",
  "tya-done-all-outline" = "done-all-outline",
  "tya-download-outline" = "download-outline",
  "tya-droplet-off-outline" = "droplet-off-outline",
  "tya-droplet-outline" = "droplet-outline",
  "tya-edit-2-outline" = "edit-2-outline",
  "tya-edit-outline" = "edit-outline",
  "tya-email-outline" = "email-outline",
  "tya-expand-outline" = "expand-outline",
  "tya-external-link-outline" = "external-link-outline",
  "tya-eye-off-2-outline" = "eye-off-2-outline",
  "tya-eye-off-outline" = "eye-off-outline",
  "tya-eye-outline" = "eye-outline",
  "tya-facebook-outline" = "facebook-outline",
  "tya-file-add-outline" = "file-add-outline",
  "tya-file-outline" = "file-outline",
  "tya-file-remove-outline" = "file-remove-outline",
  "tya-file-text-outline" = "file-text-outline",
  "tya-film-outline" = "film-outline",
  "tya-flag-outline" = "flag-outline",
  "tya-flash-off-outline" = "flash-off-outline",
  "tya-flash-outline" = "flash-outline",
  "tya-flip-outline" = "flip-outline",
  "tya-flip-2-outline" = "flip-2-outline",
  "tya-folder-add-outline" = "folder-add-outline",
  "tya-folder-outline" = "folder-outline",
  "tya-folder-remove-outline" = "folder-remove-outline",
  "tya-funnel-outline" = "funnel-outline",
  "tya-gift-outline" = "gift-outline",
  "tya-github-outline" = "github-outline",
  "tya-globe-2-outline" = "globe-2-outline",
  "tya-globe-outline" = "globe-outline",
  "tya-google-outline" = "google-outline",
  "tya-grid-outline" = "grid-outline",
  "tya-hard-drive-outline" = "hard-drive-outline",
  "tya-hash-outline" = "hash-outline",
  "tya-headphones-outline" = "headphones-outline",
  "tya-heart-outline" = "heart-outline",
  "tya-home-outline" = "home-outline",
  "tya-image-outline" = "image-outline",
  "tya-inbox-outline" = "inbox-outline",
  "tya-info-outline" = "info-outline",
  "tya-keypad-outline" = "keypad-outline",
  "tya-layers-outline" = "layers-outline",
  "tya-layout-outline" = "layout-outline",
  "tya-link-2-outline" = "link-2-outline",
  "tya-link-outline" = "link-outline",
  "tya-linkedin-outline" = "linkedin-outline",
  "tya-list-outline" = "list-outline",
  "tya-loader-outline" = "loader-outline",
  "tya-lock-outline" = "lock-outline",
  "tya-log-in-outline" = "log-in-outline",
  "tya-log-out-outline" = "log-out-outline",
  "tya-map-outline" = "map-outline",
  "tya-maximize-outline" = "maximize-outline",
  "tya-menu-2-outline" = "menu-2-outline",
  "tya-menu-arrow-outline" = "menu-arrow-outline",
  "tya-menu-outline" = "menu-outline",
  "tya-message-circle-outline" = "message-circle-outline",
  "tya-message-square-outline" = "message-square-outline",
  "tya-mic-off-outline" = "mic-off-outline",
  "tya-mic-outline" = "mic-outline",
  "tya-minimize-outline" = "minimize-outline",
  "tya-minus-circle-outline" = "minus-circle-outline",
  "tya-minus-outline" = "minus-outline",
  "tya-minus-square-outline" = "minus-square-outline",
  "tya-monitor-outline" = "monitor-outline",
  "tya-moon-outline" = "moon-outline",
  "tya-more-horizontal-outline" = "more-horizontal-outline",
  "tya-more-vertical-outline" = "more-vertical-outline",
  "tya-move-outline" = "move-outline",
  "tya-music-outline" = "music-outline",
  "tya-navigation-2-outline" = "navigation-2-outline",
  "tya-navigation-outline" = "navigation-outline",
  "tya-npm-outline" = "npm-outline",
  "tya-options-2-outline" = "options-2-outline",
  "tya-options-outline" = "options-outline",
  "tya-pantone-outline" = "pantone-outline",
  "tya-paper-plane-outline" = "paper-plane-outline",
  "tya-pause-circle-outline" = "pause-circle-outline",
  "tya-people-outline" = "people-outline",
  "tya-percent-outline" = "percent-outline",
  "tya-person-add-outline" = "person-add-outline",
  "tya-person-delete-outline" = "person-delete-outline",
  "tya-person-done-outline" = "person-done-outline",
  "tya-person-outline" = "person-outline",
  "tya-person-remove-outline" = "person-remove-outline",
  "tya-phone-call-outline" = "phone-call-outline",
  "tya-phone-missed-outline" = "phone-missed-outline",
  "tya-phone-off-outline" = "phone-off-outline",
  "tya-phone-outline" = "phone-outline",
  "tya-pie-chart-outline" = "pie-chart-outline",
  "tya-pin-outline" = "pin-outline",
  "tya-play-circle-outline" = "play-circle-outline",
  "tya-plus-circle-outline" = "plus-circle-outline",
  "tya-plus-outline" = "plus-outline",
  "tya-plus-square-outline" = "plus-square-outline",
  "tya-power-outline" = "power-outline",
  "tya-pricetags-outline" = "pricetags-outline",
  "tya-printer-outline" = "printer-outline",
  "tya-question-mark-circle-outline" = "question-mark-circle-outline",
  "tya-question-mark-outline" = "question-mark-outline",
  "tya-radio-button-off-outline" = "radio-button-off-outline",
  "tya-radio-button-on-outline" = "radio-button-on-outline",
  "tya-radio-outline" = "radio-outline",
  "tya-recording-outline" = "recording-outline",
  "tya-refresh-outline" = "refresh-outline",
  "tya-repeat-outline" = "repeat-outline",
  "tya-rewind-left-outline" = "rewind-left-outline",
  "tya-rewind-right-outline" = "rewind-right-outline",
  "tya-save-outline" = "save-outline",
  "tya-scissors-outline" = "scissors-outline",
  "tya-search-outline" = "search-outline",
  "tya-settings-2-outline" = "settings-2-outline",
  "tya-settings-outline" = "settings-outline",
  "tya-share-outline" = "share-outline",
  "tya-shake-outline" = "shake-outline",
  "tya-shield-off-outline" = "shield-off-outline",
  "tya-shield-outline" = "shield-outline",
  "tya-shopping-bag-outline" = "shopping-bag-outline",
  "tya-shopping-cart-outline" = "shopping-cart-outline",
  "tya-shuffle-2-outline" = "shuffle-2-outline",
  "tya-shuffle-outline" = "shuffle-outline",
  "tya-skip-back-outline" = "skip-back-outline",
  "tya-skip-forward-outline" = "skip-forward-outline",
  "tya-slash-outline" = "slash-outline",
  "tya-smartphone-outline" = "smartphone-outline",
  "tya-smiling-face-outline" = "smiling-face-outline",
  "tya-speaker-outline" = "speaker-outline",
  "tya-square-outline" = "square-outline",
  "tya-star-outline" = "star-outline",
  "tya-stop-circle-outline" = "stop-circle-outline",
  "tya-sun-outline" = "sun-outline",
  "tya-swap-outline" = "swap-outline",
  "tya-sync-outline" = "sync-outline",
  "tya-text-outline" = "text-outline",
  "tya-thermometer-minus-outline" = "thermometer-minus-outline",
  "tya-thermometer-outline" = "thermometer-outline",
  "tya-thermometer-plus-outline" = "thermometer-plus-outline",
  "tya-toggle-left-outline" = "toggle-left-outline",
  "tya-toggle-right-outline" = "toggle-right-outline",
  "tya-trash-2-outline" = "trash-2-outline",
  "tya-trash-outline" = "trash-outline",
  "tya-trending-down-outline" = "trending-down-outline",
  "tya-trending-up-outline" = "trending-up-outline",
  "tya-tv-outline" = "tv-outline",
  "tya-twitter-outline" = "twitter-outline",
  "tya-umbrella-outline" = "umbrella-outline",
  "tya-undo-outline" = "undo-outline",
  "tya-unlock-outline" = "unlock-outline",
  "tya-upload-outline" = "upload-outline",
  "tya-video-off-outline" = "video-off-outline",
  "tya-video-outline" = "video-outline",
  "tya-volume-down-outline" = "volume-down-outline",
  "tya-volume-mute-outline" = "volume-mute-outline",
  "tya-volume-off-outline" = "volume-off-outline",
  "tya-volume-up-outline" = "volume-up-outline",
  "tya-wifi-off-outline" = "wifi-off-outline",
  "tya-wifi-outline" = "wifi-outline",
  "tya-activity" = "activity",
  "tya-alert-circle" = "alert-circle",
  "tya-alert-triangle" = "alert-triangle",
  "tya-archive" = "archive",
  "tya-arrow-circle-down" = "arrow-circle-down",
  "tya-arrow-circle-up" = "arrow-circle-up",
  "tya-arrow-circle-left" = "arrow-circle-left",
  "tya-arrow-circle-right" = "arrow-circle-right",
  "tya-arrow-down" = "arrow-down",
  "tya-arrow-up" = "arrow-up",
  "tya-arrow-left" = "arrow-left",
  "tya-arrow-right" = "arrow-right",
  "tya-arrow-downward" = "arrow-downward",
  "tya-arrow-upward" = "arrow-upward",
  "tya-arrow-back" = "arrow-back",
  "tya-arrow-forward" = "arrow-forward",
  "tya-arrow-ios-downward" = "arrow-ios-downward",
  "tya-arrow-ios-upward" = "arrow-ios-upward",
  "tya-arrow-ios-back" = "arrow-ios-back",
  "tya-arrow-ios-forward" = "arrow-ios-forward",
  "tya-arrowhead-down" = "arrowhead-down",
  "tya-arrowhead-up" = "arrowhead-up",
  "tya-arrowhead-left" = "arrowhead-left",
  "tya-arrowhead-right" = "arrowhead-right",
  "tya-at" = "at",
  "tya-attach-2" = "attach-2",
  "tya-attach" = "attach",
  "tya-award" = "award",
  "tya-backspace" = "backspace",
  "tya-bar-chart-2" = "bar-chart-2",
  "tya-bar-chart" = "bar-chart",
  "tya-battery" = "battery",
  "tya-behance" = "behance",
  "tya-bell-off" = "bell-off",
  "tya-bell" = "bell",
  "tya-bluetooth" = "bluetooth",
  "tya-book-open" = "book-open",
  "tya-book" = "book",
  "tya-bookmark" = "bookmark",
  "tya-briefcase" = "briefcase",
  "tya-browser" = "browser",
  "tya-brush" = "brush",
  "tya-bulb" = "bulb",
  "tya-calendar" = "calendar",
  "tya-camera" = "camera",
  "tya-car" = "car",
  "tya-cast" = "cast",
  "tya-charging" = "charging",
  "tya-checkmark-circle-2" = "checkmark-circle-2",
  "tya-checkmark-circle" = "checkmark-circle",
  "tya-checkmark-square-2" = "checkmark-square-2",
  "tya-checkmark-square" = "checkmark-square",
  "tya-checkmark" = "checkmark",
  "tya-chevron-down" = "chevron-down",
  "tya-chevron-left" = "chevron-left",
  "tya-chevron-right" = "chevron-right",
  "tya-chevron-up" = "chevron-up",
  "tya-clipboard" = "clipboard",
  "tya-clock" = "clock",
  "tya-close-circle" = "close-circle",
  "tya-close-square" = "close-square",
  "tya-close" = "close",
  "tya-cloud-download" = "cloud-download",
  "tya-cloud-upload" = "cloud-upload",
  "tya-code-download" = "code-download",
  "tya-code" = "code",
  "tya-collapse" = "collapse",
  "tya-color-palette" = "color-palette",
  "tya-color-picker" = "color-picker",
  "tya-compass" = "compass",
  "tya-copy" = "copy",
  "tya-corner-down-left" = "corner-down-left",
  "tya-corner-down-right" = "corner-down-right",
  "tya-corner-left-down" = "corner-left-down",
  "tya-corner-left-up" = "corner-left-up",
  "tya-corner-right-down" = "corner-right-down",
  "tya-corner-right-up" = "corner-right-up",
  "tya-corner-up-left" = "corner-up-left",
  "tya-corner-up-right" = "corner-up-right",
  "tya-credit-card" = "credit-card",
  "tya-crop" = "crop",
  "tya-cube" = "cube",
  "tya-diagonal-arrow-left-down" = "diagonal-arrow-left-down",
  "tya-diagonal-arrow-left-up" = "diagonal-arrow-left-up",
  "tya-diagonal-arrow-right-down" = "diagonal-arrow-right-down",
  "tya-diagonal-arrow-right-up" = "diagonal-arrow-right-up",
  "tya-done-all" = "done-all",
  "tya-download" = "download",
  "tya-droplet-off" = "droplet-off",
  "tya-droplet" = "droplet",
  "tya-edit-2" = "edit-2",
  "tya-edit" = "edit",
  "tya-email" = "email",
  "tya-expand" = "expand",
  "tya-external-link" = "external-link",
  "tya-eye-off-2" = "eye-off-2",
  "tya-eye-off" = "eye-off",
  "tya-eye" = "eye",
  "tya-facebook" = "facebook",
  "tya-file-add" = "file-add",
  "tya-file-remove" = "file-remove",
  "tya-file-text" = "file-text",
  "tya-file" = "file",
  "tya-film" = "film",
  "tya-flag" = "flag",
  "tya-flash-off" = "flash-off",
  "tya-flash" = "flash",
  "tya-flip" = "flip",
  "tya-flip-2" = "flip-2",
  "tya-folder-add" = "folder-add",
  "tya-folder-remove" = "folder-remove",
  "tya-folder" = "folder",
  "tya-funnel" = "funnel",
  "tya-gift" = "gift",
  "tya-github" = "github",
  "tya-globe-2" = "globe-2",
  "tya-globe-3" = "globe-3",
  "tya-globe" = "globe",
  "tya-google" = "google",
  "tya-grid" = "grid",
  "tya-hard-drive" = "hard-drive",
  "tya-hash" = "hash",
  "tya-headphones" = "headphones",
  "tya-heart" = "heart",
  "tya-home" = "home",
  "tya-image-2" = "image-2",
  "tya-image" = "image",
  "tya-inbox" = "inbox",
  "tya-info" = "info",
  "tya-keypad" = "keypad",
  "tya-layers" = "layers",
  "tya-layout" = "layout",
  "tya-link-2" = "link-2",
  "tya-link" = "link",
  "tya-linkedin" = "linkedin",
  "tya-list" = "list",
  "tya-lock" = "lock",
  "tya-log-in" = "log-in",
  "tya-log-out" = "log-out",
  "tya-map" = "map",
  "tya-maximize" = "maximize",
  "tya-menu-2" = "menu-2",
  "tya-menu-arrow" = "menu-arrow",
  "tya-menu" = "menu",
  "tya-message-circle" = "message-circle",
  "tya-message-square" = "message-square",
  "tya-mic-off" = "mic-off",
  "tya-mic" = "mic",
  "tya-minimize" = "minimize",
  "tya-minus-circle" = "minus-circle",
  "tya-minus-square" = "minus-square",
  "tya-minus" = "minus",
  "tya-monitor" = "monitor",
  "tya-moon" = "moon",
  "tya-more-horizontal" = "more-horizontal",
  "tya-more-vertical" = "more-vertical",
  "tya-move" = "move",
  "tya-music" = "music",
  "tya-navigation-2" = "navigation-2",
  "tya-navigation" = "navigation",
  "tya-npm" = "npm",
  "tya-options-2" = "options-2",
  "tya-options" = "options",
  "tya-pantone" = "pantone",
  "tya-paper-plane" = "paper-plane",
  "tya-pause-circle" = "pause-circle",
  "tya-people" = "people",
  "tya-percent" = "percent",
  "tya-person-add" = "person-add",
  "tya-person-delete" = "person-delete",
  "tya-person-done" = "person-done",
  "tya-person-remove" = "person-remove",
  "tya-person" = "person",
  "tya-phone-call" = "phone-call",
  "tya-phone-missed" = "phone-missed",
  "tya-phone-off" = "phone-off",
  "tya-phone" = "phone",
  "tya-pie-chart-2" = "pie-chart-2",
  "tya-pie-chart" = "pie-chart",
  "tya-pin" = "pin",
  "tya-play-circle" = "play-circle",
  "tya-plus-circle" = "plus-circle",
  "tya-plus-square" = "plus-square",
  "tya-plus" = "plus",
  "tya-power" = "power",
  "tya-pricetags" = "pricetags",
  "tya-printer" = "printer",
  "tya-question-mark-circle" = "question-mark-circle",
  "tya-question-mark" = "question-mark",
  "tya-radio-button-off" = "radio-button-off",
  "tya-radio-button-on" = "radio-button-on",
  "tya-radio" = "radio",
  "tya-recording" = "recording",
  "tya-refresh" = "refresh",
  "tya-repeat" = "repeat",
  "tya-rewind-left" = "rewind-left",
  "tya-rewind-right" = "rewind-right",
  "tya-save" = "save",
  "tya-scissors" = "scissors",
  "tya-search" = "search",
  "tya-settings-2" = "settings-2",
  "tya-settings" = "settings",
  "tya-shake" = "shake",
  "tya-share" = "share",
  "tya-shield-off" = "shield-off",
  "tya-shield" = "shield",
  "tya-shopping-bag" = "shopping-bag",
  "tya-shopping-cart" = "shopping-cart",
  "tya-shuffle-2" = "shuffle-2",
  "tya-shuffle" = "shuffle",
  "tya-skip-back" = "skip-back",
  "tya-skip-forward" = "skip-forward",
  "tya-slash" = "slash",
  "tya-smartphone" = "smartphone",
  "tya-smiling-face" = "smiling-face",
  "tya-speaker" = "speaker",
  "tya-square" = "square",
  "tya-star" = "star",
  "tya-stop-circle" = "stop-circle",
  "tya-sun" = "sun",
  "tya-swap" = "swap",
  "tya-sync" = "sync",
  "tya-text" = "text",
  "tya-thermometer-minus" = "thermometer-minus",
  "tya-thermometer-plus" = "thermometer-plus",
  "tya-thermometer" = "thermometer",
  "tya-toggle-left" = "toggle-left",
  "tya-toggle-right" = "toggle-right",
  "tya-trash-2" = "trash-2",
  "tya-trash" = "trash",
  "tya-trending-down" = "trending-down",
  "tya-trending-up" = "trending-up",
  "tya-tv" = "tv",
  "tya-twitter" = "twitter",
  "tya-umbrella" = "umbrella",
  "tya-undo" = "undo",
  "tya-unlock" = "unlock",
  "tya-upload" = "upload",
  "tya-video-off" = "video-off",
  "tya-video" = "video",
  "tya-volume-down" = "volume-down",
  "tya-volume-mute" = "volume-mute",
  "tya-volume-off" = "volume-off",
  "tya-volume-up" = "volume-up",
  "tya-wifi-off" = "wifi-off",
  "tya-wifi" = "wifi",
}
